import CreateDataContext from '../CreateDataContext'
import { initialState, portfolioReducers } from './portfolio.reducers'
import {
  changeGroup,
  getEvents,
  getPrices,
  getTickersOnlyInPortfolio,
  getAllTickersInUniverse,
  loadMore,
  getScanCharts,
  updatePortfolioData,
  setLoading,
  currentScrollPosition,
  setBottom,
  deleteTicker,
  getPortfolioUsers,
  addTickers,
  cleanUp,
  changeSearchInputValue,
  changeRiskStatus,
  changeCreditRiskStatus,
  changeSector,
  changeCountry,
  changeRegion,
  changeSelectedTab,
  changeSelectedRiskTab,
  setActiveNode,
  setShowBehavioural,
  setShowPeerToggle,
  setShowCompanyToggle,
  getCreditSeries,
  getBehaviourAnalysisChartData,
  changeImpliedRating,
  getCreditSeriesComparison,
  deleteItemComparisonState,
  getNotes,
  getWhatIf,
  calculateWhatIf,
  clearDataCalculateWhatIf,
} from './portfolio.actions'

export const { Provider, Context } = CreateDataContext(
  portfolioReducers,
  {
    changeSelectedTab,
    changeSelectedRiskTab,
    changeGroup,
    loadMore,
    getTickersOnlyInPortfolio,
    getAllTickersInUniverse,
    getPrices,
    getEvents,
    getScanCharts,
    updatePortfolioData,
    setLoading,
    currentScrollPosition,
    setBottom,
    deleteTicker,
    getPortfolioUsers,
    addTickers,
    cleanUp,
    changeSearchInputValue,
    changeRiskStatus,
    changeCreditRiskStatus,
    changeImpliedRating,
    changeSector,
    changeCountry,
    changeRegion,
    setActiveNode,
    setShowBehavioural,
    setShowPeerToggle,
    setShowCompanyToggle,
    getCreditSeries,
    getBehaviourAnalysisChartData,
    getCreditSeriesComparison,
    deleteItemComparisonState,
    getNotes,
    getWhatIf,
    calculateWhatIf,
    clearDataCalculateWhatIf,
  },
  initialState,
)
